import gql from "graphql-tag";
import { DOCUMENT_FRAGMENT } from "../document/fragment";

export const USER_FRAGMENT = gql`
  fragment UserInfo on User {
    id
    address
    city
    cityOfBirth
    countryIsoCode
    countryOfBirthIsoCode
    dateOfBirth
    email
    firstname
    gender
    isLegalRepresentative
    mobilePhoneNumber
    name
    nationalityCountryIsoCode
    postcode
    sharesPercentage
    specifiedUSPerson
    type
    documents {
      ...DocumentInfo
    }
    directorAppointmentDate
    isDirector
  }
  ${DOCUMENT_FRAGMENT}
`;
